import * as definitions from 'store/definitions/certificates';

function Certificate(state = {
  collection: [],
}, action) {
  switch (action.type) {
    case definitions.FETCH_ALL_CERTIFICATES_FULFILLED:
      return {
        collection: action.payload
      }
    default:
      return state;
  }
}

export default Certificate;
